import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import { withRouter } from 'next/router'
import dynamic from 'next/dynamic'
import { FaArrowLeft } from 'react-icons/fa'
import { StatusBar } from '@capacitor/status-bar'

import isLightMode from 'helpers/isLightMode'
import useIsHomePage from 'hooks/useIsHomePage'
import { Link } from 'i18n-web/i18next'
import { Menu } from 'components/Molecules'
import { getAppRoute } from 'helpers/application'
import { getThemePath } from 'models/application'
import { isCitifydApp } from 'helpers/application'
import { useClientResponsive } from 'helpers/hooks'
const LanguageSelector = dynamic(
  () => import('components/Molecules/LanguageSelector'),
  {
    ssr: false,
  }
)
const Component = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  flex-shrink: 0;
  background-color: ${props =>
    isLightMode(props.application)
      ? props.theme.palette.grayDark
      : props.theme.palette.black};
  z-index: 100;
  padding-top: ${props => props.statusBarHeight || 0}px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
  }

  .logo {
    width: 170px;
    height: auto;
  }

  .logoLink {
    line-height: 1;
  }
`

const LeftColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const RightColumn = styled.div`
  display: flex;
  align-items: center;
`

const BackButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  opacity: 0.4;

  .icon {
    width: 22px;
    height: auto;
    color: ${props => props.theme.palette.white};
  }
`

const Header = ({
  router,
  onLogoutRedirection,
  hideMenu,
  hideLanguageSelector,
}) => {
  const [statusBarHeight, setStatusBarHeight] = useState(0)
  const isHomePage = useIsHomePage()
  const { isMobile } = useClientResponsive()

  const {
    query: { application },
  } = router

  useEffect(() => {
    if (StatusBar) {
      StatusBar.getInfo()
        .then(info => {
          setStatusBarHeight(info.height)
        })
        .catch(() => {})
    }
  }, [])

  const getHeaderData = () => {
    if (isCitifydApp(application)) {
      return {
        href: `${getAppRoute(application, 'url')}/`,
        logo: '/static/images/logo_with_text_long@3x.png',
      }
    }

    return {
      href: `${getAppRoute(application, 'url')}/events`,
      logo: `/static/images/${getThemePath(application)}/logo_header.svg`,
    }
  }

  const onBackButtonClick = () => {
    router.back()
  }

  const showBackButton = !isHomePage && isMobile

  return (
    <Component application={application} statusBarHeight={statusBarHeight}>
      <Grid>
        <Row center="xs">
          <Col className="header" xs={12}>
            <LeftColumn>
              {showBackButton && (
                <BackButton onClick={onBackButtonClick}>
                  <FaArrowLeft className="icon" />
                </BackButton>
              )}
              {!process.env.NEXT_PUBLIC_ENABLE_PAY_BY_SIGNAGE_ONLY ? (
                <Link href={getHeaderData().href}>
                  <a className="logoLink">
                    <img className="logo" src={getHeaderData().logo} />
                  </a>
                </Link>
              ) : (
                <img className="logo" src={getHeaderData().logo} />
              )}
            </LeftColumn>
            <RightColumn>
              {!hideLanguageSelector && <LanguageSelector />}
              {!hideMenu && <Menu onLogoutRedirection={onLogoutRedirection} />}
            </RightColumn>
          </Col>
        </Row>
      </Grid>
    </Component>
  )
}

Header.propTypes = {
  router: PropTypes.object,
  onLogoutRedirection: PropTypes.string,
  hideMenu: PropTypes.bool,
  hideLanguageSelector: PropTypes.bool,
}

Header.defaultProps = { logoImage: undefined }

export default withRouter(Header)
